<template>
  <div class="serviceItem-area">
    <el-form key="formSAPServiceItem" v-ref="(com, key) => $vueRefStore.setChildrenRef(key, com)" :model="data" :rules="rules" label-position="left"
      label-width="100px" class="cs-el-input-container-small">
      <el-row v-if="mode === 'bottomPrice'" :gutter="16" type="flex" class="serviceItem-content">
        <el-col :span="9" class="serviceItem-part">
          <el-row>
            <el-col>
              <span>服务名称/类型</span>
            </el-col>
            <el-col>
              <el-form-item label-width="0px" prop="Name" class="cs-no-margin-bottom">
                <span>{{data.Name}}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="15">
          <el-table class="priceCategory-table" :data="priceCategoryInfos" :row-class-name="getRowClass" :summary-method="getTabelSummaries" show-summary>
            <el-table-column label="价格类型" prop="PriceCategory">
              <template #default="{row}">{{GLOBAL.enumStudyAbroadPriceCategory.getDesc(row.PriceCategory)}}</template>
            </el-table-column>
            <el-table-column label="底价">
              <el-table-column label="加币" prop="BottomPriceCAD">
                <template #default="{row}">
                  <el-input :disabled="readonly" placeholder="请输入价格" v-model="row.BottomPriceCAD" oninput="value=value.replace(/[^0-9.]/g,'')"
                    onblur="value=!!value?value.toNumber().toFixedEx(2):null" size="small" @change="value => onPriceChange(value, row, 'BottomPriceCAD')" />
                  <span>{{Object.toCurrency(calculateTotalPrice(row.BottomPriceCAD), GLOBAL.currencyType.CAD)}}</span>
                </template>
              </el-table-column>
              <el-table-column label="人民币" prop="BottomPriceCNY">
                <template #default="{row}">
                  <el-input :disabled="readonly" placeholder="请输入价格" v-model="row.BottomPriceCNY" oninput="value=value.replace(/[^0-9.]/g,'')"
                    onblur="value=!!value?value.toNumber().toFixedEx(2):null" size="small" @change="value => onPriceChange(value, row, 'BottomPriceCNY')" />
                  <span>{{Object.toCurrency(calculateTotalPrice(row.BottomPriceCNY), GLOBAL.currencyType.CNY)}}</span>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <el-row v-else :gutter="16" type="flex" class="serviceItem-content">
        <el-col :span="5" class="serviceItem-part">
          <el-row>
            <el-col>
              <span>服务名称/类型</span>
            </el-col>
            <el-col>
              <el-form-item label-width="0px" prop="Name">
                <el-input :disabled="readonly" placeholder="请输入服务名称" v-model="data.Name" size="small" class="input-width-nolabel" />
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item label-width="0px" prop="ServiceType" class="serviceItem-noMargin">
                <el-select :disabled="readonly" v-model="data.ServiceType" placeholder="请选择服务类型" size="small" class="input-width-nolabel"
                  @change="onServiceTypeChange">
                  <el-option v-for="item in GLOBAL.enumSAServiceType.getOptions()" :key="item.value" :label="item.desc" :value="item.value" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col v-if="data.ServiceType === GLOBAL.enumSAServiceType.Course">
              <el-form-item label-width="0px" prop="Renewable" class="serviceItem-noMargin">
                <el-checkbox :disabled="readonly" v-model="data.IsVIP" size="small" class="input-width-nolabel" @change="onIsVIPChange">是否VIP</el-checkbox>
              </el-form-item>
            </el-col>
            <el-col v-else>
              <el-form-item label-width="0px" prop="Renewable" class="serviceItem-noMargin">
                <el-checkbox :disabled="readonly" v-model="data.IsDataService" size="small" class="input-width-nolabel">是否数据服务</el-checkbox>
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item label-width="0px" prop="Renewable" class="serviceItem-noMargin">
                <el-checkbox :disabled="readonly" v-model="data.Renewable" size="small" class="input-width-nolabel">是否可续费</el-checkbox>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="10" class="serviceItem-part">
          <el-table class="priceCategory-table" :data="priceCategoryInfos" :row-class-name="getRowClass" :summary-method="getTabelSummaries" show-summary>
            <el-table-column label="价格类型" prop="PriceCategory">
              <template #default="{row}">{{GLOBAL.enumStudyAbroadPriceCategory.getDesc(row.PriceCategory)}}</template>
            </el-table-column>
            <el-table-column label="销售价">
              <el-table-column label="加币" prop="SalePriceCAD">
                <template #default="{row}">
                  <el-input :disabled="readonly" placeholder="请输入价格" v-model="row.SalePriceCAD" oninput="value=value.replace(/[^0-9.]/g,'')"
                    onblur="value=!!value?value.toNumber().toFixedEx(2):null" size="small" @change="value => onPriceChange(value, row, 'SalePriceCAD')" />
                  <span>{{Object.toCurrency(calculateTotalPrice(row.SalePriceCAD), GLOBAL.currencyType.CAD)}}</span>
                </template>
              </el-table-column>
              <el-table-column label="人民币" prop="SalePriceCNY">
                <template #default="{row}">
                  <el-input :disabled="readonly" placeholder="请输入价格" v-model="row.SalePriceCNY" oninput="value=value.replace(/[^0-9.]/g,'')"
                    onblur="value=!!value?value.toNumber().toFixedEx(2):null" size="small" @change="value => onPriceChange(value, row, 'SalePriceCNY')" />
                  <span>{{Object.toCurrency(calculateTotalPrice(row.SalePriceCNY), GLOBAL.currencyType.CNY)}}</span>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column label="底价">
              <el-table-column label="加币" prop="BottomPriceCAD">
                <template #default="{row}">
                  <el-input :disabled="readonly" placeholder="请输入价格" v-model="row.BottomPriceCAD" oninput="value=value.replace(/[^0-9.]/g,'')"
                    onblur="value=!!value?value.toNumber().toFixedEx(2):null" size="small" @change="value => onPriceChange(value, row, 'BottomPriceCAD')" />
                  <span>{{Object.toCurrency(calculateTotalPrice(row.BottomPriceCAD), GLOBAL.currencyType.CAD)}}</span>
                </template>
              </el-table-column>
              <el-table-column label="人民币" prop="BottomPriceCNY">
                <template #default="{row}">
                  <el-input :disabled="readonly" placeholder="请输入价格" v-model="row.BottomPriceCNY" oninput="value=value.replace(/[^0-9.]/g,'')"
                    onblur="value=!!value?value.toNumber().toFixedEx(2):null" size="small" @change="value => onPriceChange(value, row, 'BottomPriceCNY')" />
                  <span>{{Object.toCurrency(calculateTotalPrice(row.BottomPriceCNY), GLOBAL.currencyType.CNY)}}</span>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>
        </el-col>
        <el-col :span="9">
          <el-row>
            <el-col>
              <el-row>
                <el-col :span="4">
                  <span>范围限制</span>
                </el-col>
                <el-col :span="14">
                  <el-checkbox :disabled="readonly" v-model="data.RangeLimitEnable" @change="onLimitEnableChange('Range')">时间</el-checkbox>
                  <el-checkbox :disabled="countLimitDisabled" v-model="data.CountLimitEnable" @change="onLimitEnableChange('Count')">次数
                  </el-checkbox>
                  <el-checkbox :disabled="timeLimitDisabled" v-model="data.TimeLimitEnable" @change="onLimitEnableChange('Time')">时数
                  </el-checkbox>
                </el-col>
                <el-col v-if="!readonly" :span="6" style="text-align: right;">
                  <el-button size="medium" type="text" icon="el-icon-delete" class="button-delete" @click="deleteSAPServiceItem">删除该服务</el-button>
                </el-col>
              </el-row>
            </el-col>
            <el-col v-if="data.RangeLimitEnable">
              <el-input :disabled="readonly" placeholder="请输入时间" v-model="data.RangeLimitValue" oninput="value=value.replace(/[^0-9.]/g,'')"
                onblur="value=!!value?value.toNumber().toFixedEx(2):null" size="small" class="input-width-limit">
                <template #append>
                  <el-select :disabled="readonly" placeholder="请选择" class="input-append" size="small" v-model="data.RangeLimitType"
                    @change="onRangeLimitTypeChange">
                    <el-option v-for="item in GLOBAL.enumSARangeLimitType.getOptions()" :key="item.value" :label="item.desc" :value="item.value" />
                  </el-select>
                </template>
              </el-input>
            </el-col>
            <el-col v-if="data.CountLimitEnable">
              <el-input :disabled="readonly" placeholder="请输入次数" v-model="data.CountLimitValue" oninput="value=value.replace(/[^0-9.]/g,'')"
                onblur="value=!!value?value.toNumber().toFixedEx(2):null" size="small" class="input-width-limit" @change="onLimitValueChange">
                <template #prepend>
                  <el-select :disabled="readonly" placeholder="请选择" class="input-append" size="small" v-model="data.CountLimitType">
                    <el-option v-for="item in GLOBAL.enumSACountLimitType.getOptionsByConditions(data.RangeLimitType, data.ServiceType)" :key="item.value" :label="item.desc"
                      :value="item.value" />
                  </el-select>
                </template>
                <template #append>
                  <span>次</span>
                </template>
              </el-input>
            </el-col>
            <el-col v-if="data.TimeLimitEnable">
              <el-input :disabled="readonly || (data.ServiceType === GLOBAL.enumSAServiceType.Course && !data.IsVIP)" placeholder="请输入时数"
                v-model="data.TimeLimitValue" oninput="value=value.replace(/[^0-9.]/g,'')" onblur="value=!!value?value.toNumber().toFixedEx(2):null"
                size="small" class="input-width-limit" @change="onLimitValueChange">
                <template #prepend>
                  <el-select :disabled="readonly" placeholder="请选择" class="input-append" size="small" v-model="data.TimeLimitType">
                    <el-option v-for="item in GLOBAL.enumSATimeLimitType.getOptionsByConditions(data.RangeLimitType, data.ServiceType)" :key="item.value" :label="item.desc"
                      :value="item.value" />
                  </el-select>
                </template>
                <template #append>
                  <span>小时</span>
                </template>
              </el-input>
            </el-col>
            <el-col>
              <el-alert :closable="false" v-if="showLimitError" v-bind:title="limitErrorMessage" type="error" show-icon />
              <el-alert :closable="false" v-if="showProfitError" v-bind:title="profitErrorMessage" type="error" show-icon />
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-divider />
    </el-form>
  </div>
</template>

<script>
import Vue from "vue";
import {
  calculateQuantityTotalBySI,
  calculateMarketPriceBySI,
  calculateProfitBySI,
  calculateProfitRateBySI,
} from "@/core/studyAbroadHelper";

const mixin_generalMethods = {
  created() {
    this.backupData();
  },
  methods: {
    backupData(data = this.data) {
      this.originalData = Object.clone(data);
    },
    resetData() {
      if (!this.originalData) return;
      Object.copy(this.data, this.originalData);
    },
    calculateTotalPrice(unitPrice) {
      let quantityTotal = calculateQuantityTotalBySI(this.data);
      return unitPrice * quantityTotal;
    },
    getRowClass({ row, rowIndex }) {
      return {
        totalRow: row.PriceCategory === 0,
      };
    },
    getTabelSummaries({ columns, data }) {
      const h = this.$createElement;
      const hCom = {
        class: {
          "sum-content-item": true,
        },
      };
      let sums = [];

      columns.forEach((column, index) => {
        if (column.property === "PriceCategory") {
          let sumContent = [h("pre", hCom, "市场")];
          if (this.mode === "normal") {
            sumContent.push(h("pre", hCom, "估算利润"));
          }
          sums[index] = h("div", null, sumContent);
          return;
        }

        let currency = this.GLOBAL.currencyType.CAD;
        if (column.property.endWith("CNY"))
          currency = this.GLOBAL.currencyType.CNY;
        let marketPrice = calculateMarketPriceBySI(this.data, column.property);
        let hComMarketPrice = Object.copy({}, hCom, {
          class: {
            "cs-redLabel": marketPrice < 0,
          },
        });
        let sumContent = [
          h("pre", hComMarketPrice, Object.toCurrency(marketPrice, currency)),
        ];
        if (this.mode === "normal") {
          if (column.property.startWith("SalePrice")) {
            let profitPrice = column.property.endWith("CNY")
              ? this.profitCNY
              : this.profitCAD;
            let hComProfitPrice = Object.copy({}, hCom, {
              class: {
                "cs-redLabel": profitPrice < 0,
              },
            });
            sumContent.push(
              h(
                "pre",
                hComProfitPrice,
                Object.toCurrency(profitPrice, currency)
              )
            );
          } else {
            sumContent.push(h("pre", hCom, " "));
          }
        }

        sums[index] = h("div", null, sumContent);
      });

      return sums;
    },
  },
  watch: {
    data: function (newVal) {
      this.backupData(newVal);
    },
  },
};

export default {
  name: "sapServiceItem",
  mixins: [mixin_generalMethods],
  props: {
    mode: {
      type: String,
      default: "normal",
      validator: (value) => ["normal", "bottomPrice"].contains(value),
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    estimatedCommission: {
      type: Number,
      default: 0.3,
    },
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      originalData: null,
      rules: {
        Name: [
          {
            required: true,
            message: "请输入服务名称",
            trigger: "blur",
          },
          {
            max: 250,
            message: "超过最大字数",
            trigger: "blur",
          },
        ],
        CostPriceCAD: [
          // {
          //   required: true,
          //   message: "请输入价格",
          //   trigger: "blur",
          // },
          // {
          //   validator: (rule, value, callback) => {
          //     let fixedValue = `${value}`.toNumber();
          //     if (fixedValue === 0) {
          //       callback(new Error("请输入价格"));
          //       return;
          //     }
          //     callback();
          //   },
          //   trigger: "blur",
          // },
        ],
        CostPriceCNY: [
          // {
          //   required: true,
          //   message: "请输入价格",
          //   trigger: "blur",
          // },
          // {
          //   validator: (rule, value, callback) => {
          //     let fixedValue = `${value}`.toNumber();
          //     if (fixedValue === 0) {
          //       callback(new Error("请输入价格"));
          //       return;
          //     }
          //     callback();
          //   },
          //   trigger: "blur",
          // },
        ],
        SalePriceCAD: [
          // {
          //   required: true,
          //   message: "请输入价格",
          //   trigger: "blur",
          // },
          // {
          //   validator: (rule, value, callback) => {
          //     let fixedValue = `${value}`.toNumber();
          //     if (fixedValue === 0) {
          //       callback(new Error("请输入价格"));
          //       return;
          //     }
          //     callback();
          //   },
          //   trigger: "blur",
          // },
        ],
        SalePriceCNY: [
          // {
          //   required: true,
          //   message: "请输入价格",
          //   trigger: "blur",
          // },
          // {
          //   validator: (rule, value, callback) => {
          //     let fixedValue = `${value}`.toNumber();
          //     if (fixedValue === 0) {
          //       callback(new Error("请输入价格"));
          //       return;
          //     }
          //     callback();
          //   },
          //   trigger: "blur",
          // },
        ],
      },
      showLimitError: false,
      limitErrorMessage: null,
      showProfitError: false,
      profitErrorMessage: null,
    };
  },
  computed: {
    priceCategoryInfos() {
      const _self = this;
      let [...pcInfoList] = _self.data.PriceCategoryInfos;

      let totalPCInfo = {
        Id: 0,
        Enable: true,
        ServiceItemId: _self.data.Id,
        PriceCategory: 0,
      };
      Vue.defineProperties(totalPCInfo, {
        SalePriceCAD: {
          get() {
            return _self.data.SalePriceCAD;
          },
          set(value) {
            _self.data.SalePriceCAD = value;
          },
        },
        SalePriceCNY: {
          get() {
            return _self.data.SalePriceCNY;
          },
          set(value) {
            _self.data.SalePriceCNY = value;
          },
        },
        BottomPriceCAD: {
          get() {
            return _self.data.BottomPriceCAD;
          },
          set(value) {
            _self.data.BottomPriceCAD = value;
          },
        },
        BottomPriceCNY: {
          get() {
            return _self.data.BottomPriceCNY;
          },
          set(value) {
            _self.data.BottomPriceCNY = value;
          },
        },
      });
      pcInfoList.insert(0, totalPCInfo);

      return pcInfoList;
    },
    profitCAD() {
      return calculateProfitBySI(
        this.data,
        this.estimatedCommission,
        this.GLOBAL.currencyType.CAD
      );
    },
    profitCNY() {
      return calculateProfitBySI(
        this.data,
        this.estimatedCommission,
        this.GLOBAL.currencyType.CNY
      );
    },
    countLimitDisabled() {
      if (this.readonly) return true;

      if (this.data.ServiceType !== this.GLOBAL.enumSAServiceType.NonCourse)
        return true;

      return false;
    },
    timeLimitDisabled() {
      if (this.readonly) return true;

      if (this.data.ServiceType !== this.GLOBAL.enumSAServiceType.NonCourse)
        return true;

      return false;
    },
  },
  methods: {
    deleteSAPServiceItem() {
      this.$confirm(
        `您确定要删除该服务${
          !!this.data.Name ? " - " + this.data.Name : String.empty
        }吗?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          if (!!this.data.Id) this.resetData();
          this.$emit("delete", this.data);
        })
        .catch(() => {});
    },
    onServiceTypeChange(newValue) {
      this.data.IsVIP = false;
      this.data.IsDataService = false;
      this.data.CountLimitEnable =
        newValue === this.GLOBAL.enumSAServiceType.Course;
      this.data.TimeLimitEnable = false;
      this.onLimitEnableChange("Count");
      this.onLimitEnableChange("Time");
    },
    onIsVIPChange(newValue) {
      let limitType;
      if (this.data.IsVIP) {
        this.data.TimeLimitEnable = true;
        limitType = "Time";
      } else {
        this.data.CountLimitEnable = true;
        limitType = "Count";
      }
      this.onLimitEnableChange(limitType);
    },
    onPriceChange(value, row, fieldName) {
      this.validateLimitSettings();
      this.validateProfit();
    },
    onLimitEnableChange(limitType) {
      if (!this.data[`${limitType}LimitEnable`]) {
        this.data[`${limitType}LimitType`] = null;
        this.data[`${limitType}LimitValue`] = null;
        if (limitType === "Range") {
          if (this.data.CountLimitEnable)
            this.data.CountLimitType = this.GLOBAL.enumSACountLimitType.Total;
          if (this.data.TimeLimitEnable)
            this.data.TimeLimitType = this.GLOBAL.enumSATimeLimitType.Total;
        }
        this.validateLimitSettings();
        this.validateProfit();
        return;
      }

      let newValue = null;
      let autoCloseLimitType = null;
      switch (limitType) {
        case "Range":
          newValue = this.GLOBAL.enumSARangeLimitType.Day;
          break;
        case "Count":
          newValue = this.GLOBAL.enumSACountLimitType.Total;
          autoCloseLimitType = "Time";
          break;
        case "Time":
          newValue = this.GLOBAL.enumSATimeLimitType.Total;
          autoCloseLimitType = "Count";
          break;
      }
      if (!!newValue) this.data[`${limitType}LimitType`] = newValue;

      if (!!autoCloseLimitType) {
        this.$nextTick(() => {
          this.data[`${autoCloseLimitType}LimitEnable`] = false;
          this.onLimitEnableChange(autoCloseLimitType);
        });
        return;
      }

      this.validateLimitSettings();
      this.validateProfit();
    },
    onRangeLimitTypeChange() {
      if (this.data.CountLimitEnable) {
        this.data.CountLimitType = this.GLOBAL.enumSACountLimitType.Total;
      }

      if (this.data.TimeLimitEnable) {
        this.data.TimeLimitType = this.GLOBAL.enumSATimeLimitType.Total;
      }
    },
    onLimitValueChange() {
      this.validateLimitSettings();
      this.validateProfit();
    },
    fixNumberFields() {
      this.data.CostPriceCAD = `${this.data.CostPriceCAD}`.toNumber();
      this.data.CostPriceCNY = `${this.data.CostPriceCNY}`.toNumber();
      this.data.SalePriceCAD = `${this.data.SalePriceCAD}`.toNumber();
      this.data.SalePriceCNY = `${this.data.SalePriceCNY}`.toNumber();
      this.data.BottomPriceCAD = `${this.data.BottomPriceCAD}`.toNumber();
      this.data.BottomPriceCNY = `${this.data.BottomPriceCNY}`.toNumber();
      this.data.RangeLimitValue = !!this.data.RangeLimitValue
        ? `${this.data.RangeLimitValue}`.toNumber()
        : null;
      this.data.CountLimitValue = !!this.data.CountLimitValue
        ? `${this.data.CountLimitValue}`.toNumber()
        : null;
      this.data.TimeLimitValue = !!this.data.TimeLimitValue
        ? `${this.data.TimeLimitValue}`.toNumber()
        : null;
    },
    checkAndFixLimits() {
      if (
        this.data.RangeLimitEnable &&
        (!this.data.RangeLimitType || !this.data.RangeLimitValue)
      )
        this.data.RangeLimitEnable = false;
      if (!this.data.RangeLimitEnable) {
        this.data.RangeLimitType = null;
        this.data.RangeLimitValue = null;
      }

      // if (
      //   this.data.CountLimitEnable &&
      //   (!this.data.CountLimitType || !this.data.CountLimitValue)
      // )
      //   this.data.CountLimitEnable = false;
      if (!this.data.CountLimitEnable) {
        this.data.CountLimitType = null;
        this.data.CountLimitValue = null;
      }

      // if (
      //   this.data.TimeLimitEnable &&
      //   (!this.data.TimeLimitType || !this.data.TimeLimitValue)
      // )
      //   this.data.TimeLimitEnable = false;
      if (!this.data.TimeLimitEnable) {
        this.data.TimeLimitType = null;
        this.data.TimeLimitValue = null;
      }
    },
    validateLimitSettings(scrollToError = false) {
      let isValid = true;

      // let costPriceCAD = `${this.data.CostPriceCAD}`.toNumber();
      // let costPriceCNY = `${this.data.CostPriceCNY}`.toNumber();
      // let salePriceCAD = `${this.data.SalePriceCAD}`.toNumber();
      // let salePriceCNY = `${this.data.SalePriceCNY}`.toNumber();
      // let hasPrice =
      //   !!costPriceCAD || !!costPriceCNY || !!salePriceCAD || !!salePriceCNY;
      let hasPrice = this.data.PriceCategoryInfos.some(
        (item) =>
          !!`${item.SalePriceCAD}`.toNumber() ||
          !!`${item.SalePriceCNY}`.toNumber() ||
          !!`${item.BottomPriceCAD}`.toNumber() ||
          !!`${item.BottomPriceCNY}`.toNumber()
      );
      let countLimitValue = `${this.data.CountLimitValue}`.toNumber();
      let timeLimitValue = `${this.data.TimeLimitValue}`.toNumber();

      this.limitErrorMessage = null;
      this.showLimitError = false;
      if (
        !this.data.CountLimitEnable &&
        !this.data.TimeLimitEnable &&
        !this.data.RangeLimitEnable
      ) {
        isValid = false;
        this.limitErrorMessage = "必须设置范围限制";
        this.showLimitError = !isValid;
      } else if (
        hasPrice &&
        this.data.ServiceType !== this.GLOBAL.enumSAServiceType.AutoAttrition &&
        (!this.data.CountLimitEnable || !countLimitValue) &&
        (!this.data.TimeLimitEnable || !timeLimitValue)
      ) {
        isValid = false;
        this.limitErrorMessage = "必须设置次数/时数限制";
        this.showLimitError = !isValid;
      }

      if (scrollToError && this.showLimitError) this.$el.scrollIntoView();

      return isValid;
    },
    validateProfit(scrollToError = false) {
      let isValid = true;
      let hasPrice = this.priceCategoryInfos.some(
        (item) =>
          !!`${item.SalePriceCAD}`.toNumber() ||
          !!`${item.SalePriceCNY}`.toNumber() ||
          !!`${item.BottomPriceCAD}`.toNumber() ||
          !!`${item.BottomPriceCNY}`.toNumber()
      );

      this.profitErrorMessage = null;
      this.showProfitError = false;
      let errMsg = "";
      if (hasPrice) {
        // 屏蔽利润检查
        // if (this.profitCAD < 0) {
        //   isValid = false;
        //   errMsg += "利润(加币)不能小于0; ";
        // }
        // if (this.profitCNY < 0) {
        //   isValid = false;
        //   errMsg += "利润(人民币)不能小于0; ";
        // }
      }

      if (!isValid) {
        this.profitErrorMessage = errMsg;
        this.showProfitError = !isValid;

        if (scrollToError) this.$el.scrollIntoView();
      }

      return isValid;
    },
    validate() {
      let isValid = true;

      this.fixNumberFields();

      let refCom = this.$vueRefStore.getChildrenRef("formSAPServiceItem");
      if (!!refCom) {
        refCom.validate((valid) => {
          isValid = valid;
        });
      }

      this.checkAndFixLimits();

      let isLismitValid = this.validateLimitSettings(true);
      let isProfitValid = this.validateProfit(true);

      return isValid && isLismitValid && isProfitValid;
    },
  },
  watch: {
    "data.RangeLimitEnable": function () {
      if (this.data.RangeLimitEnable) {
        this.validateLimitSettings();
        this.validateProfit();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.serviceItem-area {
  padding: 10px 10px 0 10px;

  .el-divider--horizontal {
    margin: 0;
    margin-top: 10px;
  }

  .serviceItem-content {
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;

    .serviceItem-part {
      border-right: 1px solid rgb(227, 227, 227);

      /deep/ label {
        margin-bottom: 0;
      }

      .serviceItem-noMargin {
        margin-bottom: 0;
      }
    }

    .el-checkbox {
      margin-right: 10px;
    }

    .el-divider--horizontal {
      margin: 10px 0;
    }
  }

  .input-width-nolabel {
    font-size: 15px;
    width: 90%;
  }

  .input-width {
    font-size: 15px;
    width: 80%;
  }

  .input-width-limit {
    padding: 5px 0;
    width: 70%;
  }

  .input-append {
    margin: -10px -10px;
    width: 80px;
  }

  .button-delete {
    padding: 0;
    color: #f56c6c;

    &:hover {
      opacity: 0.9;
    }
  }

  .el-alert {
    margin-top: 5px;
  }

  .sum-content-item {
    overflow: hidden;
  }
}

/deep/ .priceCategory-table {
  background-color: transparent;

  th,
  tr {
    background-color: transparent;

    &.totalRow {
      background-color: #f5f7fa;
    }
  }

  th,
  td {
    padding: 5px 0;
  }

  .cell {
    padding: 0 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/studyAbroad/priceManagement/sapServiceItem.vue